import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { getTokenScope } from "./token-scope";
import { tap } from "rxjs";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  // const token = localStorage.getItem('authToken'); // Or from AuthService
  // if (token) {
  //   req = req.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${token}`
  //     }
  //   });
  // }

  // return next(req);
    const scope = getTokenScope(req.url);

  const authToken = localStorage.getItem('authToken');
  const workspaceToken = localStorage.getItem('workspace_token');

  let tokenToUse = '';

  if (scope === 'workspace') {
    tokenToUse = workspaceToken || '';
  } else {
    tokenToUse = authToken || '';
  }

  if (tokenToUse) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${tokenToUse}`,
      },
    });
  }
  return next(req).pipe(tap({
     error :(error)=> {
       if(error.status === 401) {
        localStorage.clear();
        router.navigate(['/login']);
        }
     }
  }));
};